const ptBR = {
	results: {
		mainTitle: 'Resultados gerais',
		testHour: 'agora são as {{hour}}',
		subtitle: {
			generalRisk: 'Nível de risco geral da empresa',
			default:
				'Consulte os detalhes dos resultados de evaluação, analize cada visão de sua empresa utilizando os filtros.',
		},
	},
	evaluations: {
		progress: {
			labelDescription: '',
			header: {
				tooltip: {
					heartFeedback: '',
					user: '',
					chart: '',
				},
				responses: '',
				workCenter: '',
			},
		},
		cards: {
			header: {
				title: '',
			},
		},
	},
};

export default ptBR;
